'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Index = void 0;
const $ = require("jquery");
class Index {
    constructor() {
        $(window).on('scroll', () => {
            // 初期値
            let dataScroll = 'none';
            const scrollHeight = $(window).scrollTop();
            const windowHeight = $(window).height();
            //出現範囲
            const contentTop = Math.round($('.paramInterview').offset().top);
            const contentHeight = $('.paramInterview').outerHeight(true);
            if (scrollHeight + (windowHeight / 2) >= contentTop) {
                if (scrollHeight + windowHeight < contentTop + contentHeight) {
                    dataScroll = 'appear';
                }
            }
            else {
                dataScroll = 'none';
            }
            this.changeTab(dataScroll);
        });
        //クリックしたらメニューあがってくる
        $('.trigIndex').on('click', (e) => {
            const isShow = $(e.currentTarget).attr('data-is-show');
            if (isShow === 'false') {
                $(e.currentTarget).attr('data-is-show', 'true');
                this.disableScroll();
                // INDEXを全表示
                this.changeTab('all');
            }
            else {
                // スクロールを再開する処理
                $(e.currentTarget).attr('data-is-show', 'false');
                this.enableScroll();
                // INDEXを左下に表示
                this.changeTab('appear');
            }
        });
        $('.trigTabContent').on('click', () => {
            this.enableScroll();
        });
    }
    ;
    // タブが切り替わる処理
    changeTab(dataScroll) {
        $('.tab').attr('data-scroll', dataScroll);
    }
    // スクロールを禁止する処理
    disableScroll() {
        document.addEventListener('touchmove', this.noScroll, { passive: false });
        document.addEventListener('wheel', this.noScroll, { passive: false });
    }
    // スクロールを再開する処理
    enableScroll() {
        document.removeEventListener('touchmove', this.noScroll);
        document.removeEventListener('wheel', this.noScroll);
    }
    noScroll(e) {
        e.preventDefault();
    }
}
exports.Index = Index;
exports.default = Index;
